import { render, staticRenderFns } from "./PaymentsIcon.vue?vue&type=template&id=dd51c4a6"
import script from "./PaymentsIcon.vue?vue&type=script&lang=ts"
export * from "./PaymentsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports